<template>
    <v-app>
        <v-app-bar app>
            <v-btn color="teal darken-4" dark @click="clickToMain">{{$t('Вернуться в начало')}}</v-btn>
            <v-spacer></v-spacer>
            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn text v-on="on">
                        <v-icon class="mr-1">mdi-earth</v-icon>
                        {{$t('Сменить язык')}}
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item
                        v-for="(locale, index) in locales"
                        :key="index"
                        @click="onChangeLocale(locale)"
                    >
                        <v-list-item-title>
                            <v-icon v-if="$i18n.locale==locale.id" color="primary">mdi-check</v-icon>
                            {{ locale.name }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>

        <v-content>
            <router-view></router-view>
        </v-content>

        <v-footer app>
            <!-- -->
        </v-footer>
    </v-app>
</template>

<script>
import { mapActions } from 'vuex';
import { LocaleService } from './services/storage.service';

export default {
    name: 'App',

    components: {},

    data: () => ({
        //
    }),
    computed: {
        locales() {
            return LocaleService.locales;
        }
    },
    methods: {
        ...mapActions('print', ['cancelAllRequests']),
        clickToMain() {
            this.cancelAllRequests();
            this.$router.push('/');
        },
        onChangeLocale(locale) {
            this.$i18n.locale = locale.id;
            LocaleService.setLocale(locale.id);
        }
    }
};
</script>

<style>
#styled-input {
    max-height: 200px;
    font-size: 16pt;
    font-weight: bold;
}
.styled-input label[for] {
    font-size: 14pt;
}
.v-icon.v-icon.v-icon--link {
    font-size: 30pt;
}
.v-data-table table td {
    font-size: 24px;
}
</style>